/* ==========================================================================
   Sakoon landing page
   Own handlers only — does not depend on lp_new.js bindings.
   Delegated events so theme-editor section reloads keep working.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof window.jQuery === 'undefined') return;

  var $ = window.jQuery;

  /* Smooth scroll for in-page anchors on the landing page */
  $(document).on('click', '.sakoon-hero a[href^="#"]', function (event) {
    var href = $(this).attr('href');
    if (!href || href === '#') return;

    var target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ========================================================================
     SP Plans — plan selection
     One card in each `[data-sp-plans]` group carries `.is-selected`, which is
     what drives the tick badge and the filled button. The starting card comes
     from the section's "Selected by default" setting.
     ======================================================================== */

  function selectPlan($card) {
    var $group = $card.closest('[data-sp-plans]');
    if (!$group.length) return;

    $group.find('.sp-plan').removeClass('is-selected').attr('aria-checked', 'false').attr('tabindex', '-1');
    $card.addClass('is-selected').attr('aria-checked', 'true').attr('tabindex', '0');
  }

  function initPlans(scope) {
    var $scope = $(scope || document);
    var $groups = $scope.find('[data-sp-plans]').add($scope.filter('[data-sp-plans]'));

    $groups.each(function () {
      var $group = $(this);
      var $cards = $group.find('.sp-plan');
      if (!$cards.length) return;

      var index = parseInt($group.attr('data-sp-default'), 10);
      if (isNaN(index) || index < 1) index = 1;
      if (index > $cards.length) index = 1;

      selectPlan($cards.eq(index - 1));
    });
  }

  $(document).on('click', '.sp-plan', function () {
    selectPlan($(this));
  });

  /* Enter/Space on the card itself. Skipped when the focus is on a control
     inside it — the browser already turns those keys into a click there. */
  $(document).on('keydown', '.sp-plan', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    if ($(event.target).closest('.sp-plans__btn').length) return;

    event.preventDefault();
    selectPlan($(this));
  });

  /* ========================================================================
     SP FAQ — one answer open at a time
     The items are native <details>, so opening and closing needs no script;
     this only closes the siblings when the list asks for it. `toggle` does not
     bubble, so it is captured rather than delegated.
     ======================================================================== */

  document.addEventListener(
    'toggle',
    function (event) {
      var item = event.target;
      if (!item.classList || !item.classList.contains('sp-qa__item')) return;
      if (!item.open) return;

      var list = item.closest('[data-sp-qa][data-sp-single]');
      if (!list) return;

      list.querySelectorAll('.sp-qa__item[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    },
    true
  );

  /* ========================================================================
     SP Video Image Review — inline playback
     Nothing downloads until someone asks for it: the element carries
     `preload="none"` and the merchant's thumbnail as its poster, so a row of
     four slides costs four images. Controls and sound arrive on first play,
     which browsers permit because the play is a direct answer to the click.
     ======================================================================== */

  function pauseReviewVideos(scope, except) {
    var videos = (scope || document).querySelectorAll('[data-sp-vir-video]');

    Array.prototype.forEach.call(videos, function (video) {
      if (video === except) return;
      if (video.paused) return;
      video.pause();
    });
  }

  $(document).on('click', '[data-sp-vir-play]', function () {
    var frame = this.closest('.sp-vir__frame');
    if (!frame) return;

    var video = frame.querySelector('[data-sp-vir-video]');
    if (!video) return;

    /* One at a time — two testimonials talking over each other is unusable */
    pauseReviewVideos(document, video);

    frame.classList.add('is-playing');
    video.controls = true;

    var started = video.play();
    /* Older Safari returns nothing from play() rather than a promise */
    if (started && started.catch) {
      started.catch(function () {
        frame.classList.remove('is-playing');
        video.controls = false;
      });
    }
  });

  /* Media events do not bubble, so this is captured rather than delegated —
     same reason as the FAQ `toggle` listener above. Putting the button back
     makes a finished slide read as a poster again instead of a black frame. */
  document.addEventListener(
    'ended',
    function (event) {
      var video = event.target;
      if (!video.hasAttribute) return;
      if (!video.hasAttribute('data-sp-vir-video')) return;

      var frame = video.closest('.sp-vir__frame');
      if (frame) frame.classList.remove('is-playing');

      video.controls = false;
      video.currentTime = 0;
    },
    true
  );

  /* Slick triggers this on the track it owns. A video left playing after the
     slide scrolls away keeps talking with nothing to look at. */
  $(document).on('beforeChange', '[data-sp-vir-track]', function () {
    pauseReviewVideos(this, null);
  });

  /* ========================================================================
     SP Plans — dispatch cut-off countdown
     Counts down to the next occurrence of the item's cut-off time in the
     visitor's own timezone, so it rolls over instead of sitting at zero.
     ======================================================================== */

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function tickTimers() {
    var nodes = document.querySelectorAll('.sp-plans__timer[data-sp-countdown]');
    if (!nodes.length) return;

    var now = new Date();

    Array.prototype.forEach.call(nodes, function (node) {
      var hour = parseInt(node.getAttribute('data-hour'), 10);
      var minute = parseInt(node.getAttribute('data-minute'), 10);
      if (isNaN(hour)) return;
      if (isNaN(minute)) minute = 0;

      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);

      var seconds = Math.floor((target - now) / 1000);
      node.textContent =
        pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor(seconds / 60) % 60) + ':' + pad(seconds % 60);
    });
  }

  /* ========================================================================
     SP Plans — add to cart
     Same process as the theme's other landing pages: an AJAX POST of
     { id, quantity, selling_plan } to /cart/add.js, then hand off to UpCart.

     The steps are strictly sequential — add, re-read the cart, only then open
     the drawer — because opening it any earlier shows the cart as it was
     before this item went in. The button stays in its loading state for the
     whole sequence.

     The checkout route is the exception on both counts: it skips the drawer
     entirely, and it is the only route that carries the card's `sp-plan-addon`
     blocks along with the main variant. UpCart adds its own gifts whenever the
     drawer opens, so doing it here as well would double them up.

     Skipping the drawer takes more than not calling it — UpCart patches
     `fetch` and `XMLHttpRequest` and opens on any /cart/add.js it sees, ours
     included. See `quietFetch` below.
     ======================================================================== */

  function cartAddUrl() {
    var base = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return base + '.js';
  }

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function updateCartCount(cart) {
    var $count = $('.cart_count_js');
    if (!$count.length || !cart) return;

    if (cart.item_count > 0) {
      $count.text(cart.item_count).show();
    } else {
      $count.text('').hide();
    }
  }

  /* A `fetch` UpCart has not patched.

     The app embed loads before this file and replaces `window.fetch` and
     `XMLHttpRequest` with wrappers that open the drawer the moment they see a
     /cart/add.js go past — which is why the drawer flashes on the way to
     checkout even though nothing here asks for it. A same-origin iframe gets
     its own untouched copies of both, so a request sent through one is
     invisible to those wrappers.

     The iframe stays in the document on purpose: detaching it tears down its
     window and takes the function with it. Falls back to the patched `fetch`
     if an iframe cannot be made, in which case the CSS guard below is what
     keeps the drawer from painting. */
  function quietFetch() {
    if (quietFetch.fn) return quietFetch.fn;

    try {
      var frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      document.body.appendChild(frame);

      var pristine = frame.contentWindow && frame.contentWindow.fetch;
      if (typeof pristine === 'function') quietFetch.fn = pristine.bind(frame.contentWindow);
    } catch (e) {
      /* Sandboxed or otherwise unavailable — fall through to the patched one */
    }

    if (!quietFetch.fn && typeof window.fetch === 'function') quietFetch.fn = window.fetch.bind(window);
    return quietFetch.fn;
  }

  /* Where the checkout route lands.

     A discount code is applied by *visiting* Shopify's /discount/CODE endpoint,
     which sets it and forwards on — there is no cart-AJAX call that does it, so
     it has to be the navigation rather than another request. `redirect` has to
     be encoded, since /checkout is a path inside a query value. An unrecognised
     code is ignored and the shopper still lands on checkout, so a typo costs a
     discount but never strands anyone. */
  function checkoutUrl(discount) {
    if (!discount) return '/checkout';
    return '/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent('/checkout');
  }

  /* Add the whole basket and leave, without the drawer getting a turn. There is
     deliberately no /cart.js re-read here: the page is about to be replaced, so
     it buys nothing, and that round trip was most of the window the drawer was
     opening in. */
  function addThenCheckout(items, discount, onError) {
    var send = quietFetch();
    if (!send) {
      onError();
      return;
    }

    document.documentElement.classList.add('sp-checkout-redirecting');

    send(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (body) {
            throw body;
          });
        }
        window.location.href = checkoutUrl(discount);
      })
      .catch(function (body) {
        document.documentElement.classList.remove('sp-checkout-redirecting');
        onError(body);
      });
  }

  function openDrawer(done) {
    /* UpCart's own hook: refreshes its contents and opens, in that order */
    if (typeof window.upcartRegisterAddToCart === 'function') {
      window.upcartRegisterAddToCart();
      done();
      return;
    }

    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
      /* Refresh is asynchronous and returns nothing to wait on, so give it a
         beat before opening rather than flashing the stale contents. */
      window.setTimeout(function () {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        done();
      }, 300);
      return;
    }

    /* No drawer on the page — the cart is the only place left to send them */
    window.location.href = cartUrl();
  }

  $(document).on('click', '[data-sp-add]', function (event) {
    event.preventDefault();

    var $button = $(this);
    if ($button.hasClass('is-loading')) return;
    if ($button.is('[disabled]')) return;

    var id = $button.attr('data-variant-id');
    if (!id) return;

    var data = {
      /* A number, not the raw attribute string: on the checkout route this goes
         into a JSON body untouched, and /cart/add.js wants an integer id there. */
      id: parseInt(id, 10),
      quantity: parseInt($button.attr('data-quantity'), 10) || 1
    };

    var sellingPlan = $button.attr('data-selling-plan');
    if (sellingPlan) data.selling_plan = parseInt(sellingPlan, 10);

    var after = $button.attr('data-after') || 'drawer';

    /* Add-ons ride along on the checkout route only. On every other route the
       drawer opens and UpCart puts its own gifts in, so adding them here as
       well would double them up. */
    var items = [data];
    if (after === 'checkout') {
      $button
        .closest('.sp-plans__cart')
        .find('[data-sp-addon]')
        .each(function () {
          var addonId = this.getAttribute('data-variant-id');
          if (!addonId) return;
          items.push({
            id: parseInt(addonId, 10),
            quantity: parseInt(this.getAttribute('data-quantity'), 10) || 1
          });
        });
    }

    $button.addClass('is-loading').attr('aria-busy', 'true');

    function stopLoading() {
      $button.removeClass('is-loading').removeAttr('aria-busy');
    }

    function fail(body) {
      stopLoading();

      var message = 'Sorry — that could not be added to your cart.';
      if (body && body.description) message = body.description;
      window.alert(message);
    }

    /* The checkout route never touches jQuery: its request goes out through an
       unpatched `fetch` so UpCart never sees the add, and it navigates the
       moment the add lands. One request for the whole basket also means the
       add-ons cannot half-land. */
    if (after === 'checkout') {
      addThenCheckout(items, $button.attr('data-discount'), fail);
      return; /* the spinner stays up while the page navigates */
    }

    $.ajax({ type: 'POST', url: cartAddUrl(), data: data, dataType: 'json' })
      /* Re-read the cart before anything is shown, so whatever opens next is
         reading a cart that already contains this item. */
      .then(function () {
        return $.getJSON(cartUrl() + '.js');
      })
      .done(function (cart) {
        updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('sp:cart:added', { detail: { item: data, items: items } }));

        if (after === 'cart') {
          window.location.href = cartUrl();
          return;
        }

        if (after !== 'drawer') {
          stopLoading();
          return;
        }

        openDrawer(stopLoading);
      })
      .fail(function (xhr) {
        fail(xhr && xhr.responseJSON);
      });
  });

  $(function () {
    initPlans(document);
    tickTimers();
    window.setInterval(tickTimers, 1000);
  });

  /* Theme editor: re-seed the default after a section reload, and follow the
     merchant's selection in the sidebar so the card they are editing is lit. */
  $(document).on('shopify:section:load', function (event) {
    initPlans(event.target);
    tickTimers();
  });

  $(document).on('shopify:block:select', function (event) {
    var $card = $(event.target).closest('.sp-plan');
    if (!$card.length) $card = $(event.target).find('.sp-plan').first();
    if ($card.length) selectPlan($card);
  });
})();
